module.exports = __webpack_public_path__ + "img/plus.f2c82406.svg";